import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { baseErrorMessages } from './baseErrorMessages';

export const resetPasswordErrorMessages: ErrorMessages = {
  ...baseErrorMessages,
  404: {
    title: 'Nie znaleziono użytkownika',
    detail: 'Nie znaleziono użytkownika o podanym adresie e-mail. Proszę sprawdzić, czy adres jest poprawny.',
  },
  [ErrorCodes.NOT_FOUND.USER]: {
    title: 'Nie znaleziono użytkownika',
    detail: 'Nie znaleziono użytkownika o podanym adresie e-mail. Proszę sprawdzić, czy adres jest poprawny.',
  },
};
